module.exports = __webpack_public_path__ + "img/us.1ded3122.svg";